import { BasicMenuItemOption, NestedMenuItemOption } from 'ui/menu';

export enum TableFilter {
  /** Campaign Filters */
  CAMPAIGN_TYPE = 'campaignTypes',
  CAMPAIGN_LABELS = 'labelIds',
  CAMPAIGN_MEDIUM = 'messageMediums',
  /** Experiment Filters */
  EXPERIMENT_MODIFIED_BY = 'modifiedBy',
  EXPERIMENT_TEST_SUBJECTS = 'experimentTypes',
  EXPERIMENT_WINNING_CRITERIA = 'winningCriteria',
  EXPERIMENT_SYSTEM_WINNING_CRITERIA = 'winningCriteriaSystemConversion',
  EXPERIMENT_CUSTOM_WINNING_CRITERIA = 'winningCriteriaCustomConversion',
  EXPERIMENT_WINNER_SELECTED = 'winnerSelected',
  EXPERIMENT_SPLIT_VARIATIONS_RANDOMLY = 'splitVariationsEvenly',
}

export type ExperimentsTableMenuItem = {
  id: string;
  labelKey: string;
  isTitle?: boolean;
};

export type ExperimentsTableMenuItemOption = NestedMenuItemOption & {
  isVisible: boolean;
};

export type ExperimentsTableOptionState = {
  menuItems?: ExperimentsTableMenuItemOption[];
  loading: boolean;
  error: boolean;
};

export type ExperimentsTableFilterOptions = {
  [k in TableFilter]?: BasicMenuItemOption[];
};

export type ExperimentsTableFilterPayload = {
  options: ExperimentsTableFilterOptions;
  translations: Record<string, string>;
};

export type ExperimentsTableFilterOptionPayload = {
  projectId: number;
  isWhatsAppFFOn?: boolean;
};
